export default function UserID({ color='var(--accent)', ...props }) {
	return <svg width="53" height="42" {...props} viewBox="0 0 53 42" xmlns="http://www.w3.org/2000/svg" fill='none'>
		<path
			stroke={color}
			d="M7.5 32.5C11.1667 27.8333 20.6 21.3 29 32.5M33.5 16H43.5M33.5 24H43.5M6 40H47C49.2091 40 51 38.2091 51 36V6C51 3.79086 49.2091 2 47 2H6C3.79086 2 2 3.79086 2 6V36C2 38.2091 3.79086 40 6 40ZM25 15.5C25 19.0899 22.0899 22 18.5 22C14.9101 22 12 19.0899 12 15.5C12 11.9101 14.9101 9 18.5 9C22.0899 9 25 11.9101 25 15.5Z"
		/>
	</svg>
}